module.exports = __webpack_public_path__ + "img/double-socket.6e14fd5c.svg";